module.exports = __webpack_public_path__ + "img/280.c76efb8b.jpg";